import React from 'react';
import SplitButton from '../Button/SplitButton_original';

/**
 * Injects entity log context into SplitButton children and adds a log-only SplitButton when missing.
 */
export function enhanceDetailRightButtons({
    rightButtons,
    isDrawer,
    dataProviderName,
    recordId,
    detailStack,
    title,
    userCapabilities,
}) {
    if (!isDrawer || !dataProviderName || !recordId) {
        return rightButtons;
    }

    const entityLogContext = {
        model: dataProviderName,
        entityId: recordId,
        detailStack,
        title,
        disabled: userCapabilities && !userCapabilities[dataProviderName + '.view'],
    };

    const enhance = (child) => {
        if (React.isValidElement(child) && Array.isArray(child.props?.actions)) {
            return React.cloneElement(child, { entityLogContext });
        }
        return child;
    };

    const base = Array.isArray(rightButtons) ? rightButtons : [];
    const enhanced = base.map(enhance);
    const hasSplit = enhanced.some(
        (c) => React.isValidElement(c) && Array.isArray(c.props?.actions)
    );

    if (!hasSplit) {
        return [
            ...enhanced,
            <SplitButton key="entity-log" actions={[]} entityLogContext={entityLogContext} />,
        ];
    }

    return enhanced;
}
